const GROUP_EMAIL_APIS = [
  "/common/hotel-detail",
  "/common/copy-hotel",
  "/core/api/v1/groupaccess/UpdateUser",
  "/core/api/v1/reports/get-group-sales-statistics",
  "/core/api/v1/reports/get-group-roomrev-statistics",
  "/core/api/v1/reports/get-group-pickup-statistics",
  "/core/api/v1/reports/get-group-payment-statistics",
  "/core/api/v1/reports/get-group-tax-rp-statistics",
  "/core/api/v1/reports/check-if-group-reports-enabled",
  "/core/api/v1/account/get-single",
  "/core/api/v1/account/get-accountId",
  "/core/api/v1/account/get-csm-details",
  "/core/api/v1/account-ledger/get-account-balance",
  "/core/api/v1/payments/razorpay/capture-account-dues-payment",
  "/core/api/v1/account-ledger/download-invoice",
];

export default function setupAxios(axios, store) {
  const Spring = `${process.env.REACT_APP_SPRING_API_URL}`;
  const Django = `${process.env.REACT_APP_API_URL}`;

  axios.interceptors.request.use(
    (config) => {
      let data = store.getState();
      const {
        auth: { token, selectedHotel },
      } = store.getState();
      const isDjango = config.url.split("/")[0] === Django;
      if (token) {
        config.headers.Authorization = token;
      }
      if (selectedHotel) {
        if (!config.params) {
          config.params = {};
        }

        if (!config.url?.includes("hotel_id="))
          config.params.hotel_id = selectedHotel.hotelId;
        if (!config.url?.includes("hotelId="))
          config.params.hotelId = selectedHotel.hotelId;
      }

      const url = config.url || "";
      const groupEmail = localStorage.getItem("groupEmail");
      const shouldAttachEmailId = GROUP_EMAIL_APIS.some((path) =>
        url.includes(path)
      );
      const emailIdAlreadyInUrl = /[?&]emailId=/.test(url);
      if (
        shouldAttachEmailId &&
        groupEmail &&
        groupEmail !== "null" &&
        groupEmail !== "undefined" &&
        !emailIdAlreadyInUrl &&
        !config.params?.emailId
      ) {
        if (!config.params) {
          config.params = {};
        }
        config.params.emailId = groupEmail;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );
}
